"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomDialog = _interopRequireDefault(require("../../../../../Shared/Components/CustomDialog"));
var _CustomDialogSelect = _interopRequireDefault(require("../../../../../Shared/Components/CustomDialogSelect"));
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _FastConfigurationRow = _interopRequireDefault(require("../FastConfigurationRow"));
var _FastConfigurationSelect = _interopRequireDefault(require("../FastConfigurationSelect"));
var _i18n = require("../../../../../Framework/i18n");
require("./Styles.scss");
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _merge = _interopRequireDefault(require("lodash/merge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FastConfiguration = function FastConfiguration(_ref) {
  var optionclassifications = _ref.optionclassifications,
    options = _ref.options,
    FastConfigurationRow = _ref.FastConfigurationRow,
    FastConfigurationSelect = _ref.FastConfigurationSelect,
    onOptionclassificationSelect = _ref.onOptionclassificationSelect,
    onOptionSelect = _ref.onOptionSelect,
    isLoading = _ref.isLoading,
    languageSettings = _ref.languageSettings,
    channelSettings = _ref.channelSettings,
    PriceComponent = _ref.PriceComponent,
    calculation = _ref.calculation,
    onDoneClick = _ref.onDoneClick,
    show = _ref.show,
    onClose = _ref.onClose;
  var _useState = (0, _react.useState)({
      index: 0,
      content: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    productPartSelected = _useState2[0],
    setProductPartSelected = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOptionsDialogOpen = _useState4[0],
    setOptionsDialogOpen = _useState4[1];
  var getStyles = function getStyles(index) {
    return {
      detailsDialog: {
        top: 'calc(103px + 50 * (' + index + 'px + 1px)',
        left: '40%',
        width: 10,
        height: 200,
        position: 'absolute'
      }
    };
  };
  var getSelectedOption = function getSelectedOption(optionClassification) {
    return optionClassification.selectedoptions ? optionClassification.selectedoptions.length === 1 ? optionClassification.selectedoptions[0] : optionClassification : undefined;
  };
  var getUpdatedOptions = function getUpdatedOptions() {
    var optionClassification = productPartSelected;
    var updatedOptions = [];
    var _iterator = _createForOfIteratorHelper(options),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var option = _step.value;
        var uo = option;
        if ((0, _isArray["default"])(optionClassification.selectedoptions)) {
          var _iterator2 = _createForOfIteratorHelper(optionClassification.selectedoptions),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var selectedOption = _step2.value;
              if (selectedOption.identifier === option.identifier) {
                uo = (0, _merge["default"])({}, option, selectedOption);
              } else if (option.option_group && (0, _isArray["default"])(option.option_group.children)) {
                var _iterator3 = _createForOfIteratorHelper(option.option_group.children),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var item = _step3.value;
                    if (selectedOption.identifier === item.identifier) {
                      uo = (0, _merge["default"])({}, option, selectedOption);
                      break;
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        updatedOptions.push(uo);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return updatedOptions;
  };
  var onFocus = function onFocus(optionClassification) {
    onOptionclassificationSelect(optionClassification, false);
  };
  var selectOptionAndCloseDialog = function selectOptionAndCloseDialog(option) {
    onOptionSelect(option);
    closeOptionsDialog();
  };
  var closeOptionsDialog = function closeOptionsDialog() {
    setOptionsDialogOpen(false);
  };
  var openOptionsDialog = function openOptionsDialog(index, content) {
    setOptionsDialogOpen(true);
    setProductPartSelected({
      index: index,
      content: content
    });
  };
  var toggleOptionsDialog = function toggleOptionsDialog(index) {
    var productPart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    isOptionsDialogOpen ? closeOptionsDialog() : openOptionsDialog(index, productPart);
  };
  var renderRows = function renderRows() {
    return optionclassifications.map(function (optionClassification, index) {
      return /*#__PURE__*/_react["default"].createElement(FastConfigurationRow, {
        key: 'optionclassificationitem' + optionClassification.identifier,
        optionclassification: optionClassification
      }, /*#__PURE__*/_react["default"].createElement(FastConfigurationSelect, {
        optionClassification: optionClassification,
        options: options,
        onOptionclassificationSelect: onOptionclassificationSelect,
        onOptionSelect: onOptionSelect,
        isLoading: isLoading,
        languageSettings: languageSettings,
        channelSettings: channelSettings,
        closeDialog: closeOptionsDialog,
        getValue: getSelectedOption,
        onFocus: onFocus,
        rowIndex: index,
        toggleDialog: toggleOptionsDialog
      }));
    });
  };
  var renderHeader = function renderHeader() {
    return null;
  };
  var renderFooter = function renderFooter() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "fastconfiguration-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "fastconfiguration-price"
    }, /*#__PURE__*/_react["default"].createElement(PriceComponent, {
      calculation: calculation,
      title: (0, _i18n.T)('price.label')
    })), /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
      className: 'fastconfiguration-done',
      onClick: onDoneClick,
      variant: "contained"
    }, (0, _i18n.T)('fastconfiguration.toConfigurator')));
  };
  var renderComponent = function renderComponent() {
    var _getStyles = getStyles(productPartSelected.index),
      detailsDialog = _getStyles.detailsDialog;
    var selectedOption = getSelectedOption(productPartSelected.content);
    var updatedOptions = getUpdatedOptions();
    return /*#__PURE__*/_react["default"].createElement(_CustomDialog["default"], {
      open: show,
      onCancel: onClose,
      onClose: onClose,
      dialogTitle: (0, _i18n.T)('fastConfiguration.dialogTitle'),
      className: 'fastconfiguration-dialog'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "fastconfiguration"
    }, renderHeader(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "fastconfiguration-rows-wrapper"
    }, renderRows()), renderFooter()), isOptionsDialogOpen ? /*#__PURE__*/_react["default"].createElement("div", {
      style: detailsDialog
    }, /*#__PURE__*/_react["default"].createElement(_CustomDialogSelect["default"], {
      options: updatedOptions,
      show: isOptionsDialogOpen,
      isLoading: isLoading,
      onSelectOption: selectOptionAndCloseDialog,
      selectedOption: selectedOption,
      selectedOptionProperty: 'identifier'
    })) : null);
  };
  return renderComponent();
};
FastConfiguration.defaultProps = {
  options: [],
  optionclassifications: [],
  onOptionclassificationSelect: function onOptionclassificationSelect() {},
  onOptionSelect: function onOptionSelect() {},
  FastConfigurationRow: _FastConfigurationRow["default"],
  FastConfigurationSelect: _FastConfigurationSelect["default"],
  calculation: {},
  onDoneClick: function onDoneClick() {}
};
var _default = exports["default"] = FastConfiguration;